/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoRankingEntry = {
    properties: {
        totoPlayer: {
            type: 'TotoPlayerSmall',
            isRequired: true,
        },
        points: {
            type: 'number',
            isRequired: true,
        },
        rank: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
